"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
class Query {
}
exports.Query = Query;
class KeyQuery extends Query {
    constructor(key) {
        super();
        this.key = key;
    }
}
exports.KeyQuery = KeyQuery;
class VoidQuery extends Query {
}
exports.VoidQuery = VoidQuery;
class IdQuery extends KeyQuery {
    constructor(id) {
        super(id.toString());
        this.id = id;
    }
}
exports.IdQuery = IdQuery;
class IdsQuery extends KeyQuery {
    constructor(ids) {
        super(ids.toString());
        this.ids = ids;
    }
}
exports.IdsQuery = IdsQuery;
class AllObjectsQuery extends KeyQuery {
    constructor() {
        super('allObjects');
    }
}
exports.AllObjectsQuery = AllObjectsQuery;
class ObjectQuery extends Query {
    constructor(value) {
        super();
        this.value = value;
    }
}
exports.ObjectQuery = ObjectQuery;
class ObjectsQuery extends Query {
    constructor(values) {
        super();
        this.values = values;
    }
}
exports.ObjectsQuery = ObjectsQuery;
class ObjectRelationsQuery extends ObjectQuery {
    constructor(value, relations = []) {
        super(value);
        this.value = value;
        this.relations = relations;
    }
}
exports.ObjectRelationsQuery = ObjectRelationsQuery;
class PaginationQuery extends Query {
}
exports.PaginationQuery = PaginationQuery;
class PaginationOffsetLimitQuery extends PaginationQuery {
    constructor(offset, limit) {
        super();
        this.offset = offset;
        this.limit = limit;
    }
}
exports.PaginationOffsetLimitQuery = PaginationOffsetLimitQuery;
class DictionaryQuery extends Query {
    constructor(dictionary) {
        super();
        this.dictionary = dictionary;
    }
}
exports.DictionaryQuery = DictionaryQuery;
class DictionaryRelationsQuery extends DictionaryQuery {
    constructor(dictionary, relations = []) {
        super(dictionary);
        this.dictionary = dictionary;
        this.relations = relations;
    }
}
exports.DictionaryRelationsQuery = DictionaryRelationsQuery;
